// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._6FEMO{padding:8px}@media screen and (min-width:400px){._6FEMO{padding:16px}}@media screen and (min-width:768px){._6FEMO{padding:0}}@media screen and (min-width:768px){.KzD9h{display:flex;border:1px solid #e2e2e2;background:#fff;border-radius:8px}}.t5RGx{width:144px;flex-shrink:0;margin:16px 8px 16px 16px}@media screen and (min-width:1552px){.t5RGx{width:200px}}.tqz-i{flex:1}.siJsD{position:sticky!important;top:64px;width:144px;height:144px;background-color:#e2e2e2;border-radius:4px;-o-object-fit:cover;object-fit:cover}@media screen and (min-width:1552px){.siJsD{width:200px;height:200px}}.bvrod{padding:16px;border:1px solid #e2e2e2;background:#fff;border-radius:8px}@media screen and (min-width:768px){.bvrod{padding-top:0;border:0;border-radius:0}}.n2x2d{margin:0;color:#2d2d2d;font-size:20px;font-weight:700;line-height:32px}@media screen and (min-width:768px){.n2x2d{display:none}}._0rgV1{padding-top:32px;border-top:1px solid #e2e2e2;margin:16px 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": "_6FEMO",
	"main": "KzD9h",
	"imageContainer": "t5RGx",
	"body": "tqz-i",
	"image": "siJsD",
	"items": "bvrod",
	"itemsLength": "n2x2d",
	"footer": "_0rgV1"
};
module.exports = ___CSS_LOADER_EXPORT___;
